<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div class="AccordianDiv">
					<p-accordion>
						<p-accordionTab
							header="Scan Location on Map {{ MapExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
							[(selected)]="MapExpand"
							[disabled]="IsLoading() == true"
							(click)="UpdateMapStylesAndListeners()"
						>
							<div>
								<p-gmap *ngIf="ShowMap == true" [overlays]="overlays" [options]="options" [style]="{ width: '100%', height: '300px' }"></p-gmap>
							</div>
						</p-accordionTab>
					</p-accordion>
				</div>

				<!--Menu Bar-->
				<div style="background-color: #ffffff">
					<div class="OptionsDiv">
						<div class="OptionsGrid">
							<label>School:</label>
							<caass-schoolselector
								style="grid-column: 2 / 7"
								[Disabled]="IsLoading()"
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
							>
							</caass-schoolselector>

							<label>Start Date:</label>
							<p-calendar
								[disabled]="IsLoading() == true"
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="StartDate"
								name="StartDate"
								(ngModelChange)="onStartDateChange($event)"
							></p-calendar>

							<label>End Date:</label>
							<p-calendar
								[disabled]="IsLoading() == true"
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="EndDate"
								name="EndDate"
								(ngModelChange)="onEndDateChange($event)"
							></p-calendar>

							<label>Grade Level:</label>
							<p-dropdown
								[disabled]="IsLoading() == true"
								[options]="lstGradeLevel"
								[(ngModel)]="GradeLevel"
								optionLabel="GradeLevelDesc"
								[filter]="true"
								filterBy="GradeLevelDesc"
								[showClear]="false"
								placeholder="Select a Grade Level"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="GradeLevel">
										<div class="form-control NoBorder" style="text-align: left">
											{{ GradeLevel.GradeLevelDesc }}
										</div>
									</div>
								</ng-template>
								<ng-template let-GradeLevelItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ GradeLevelItem.GradeLevelDesc }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>

							<label>Academy:</label>
							<p-dropdown
								[disabled]="IsLoading() == true"
								[options]="lstAcademy"
								[(ngModel)]="Academy"
								optionLabel="AcademyDesc"
								[filter]="true"
								filterBy="AcademyDesc"
								[showClear]="false"
								placeholder="Select an Academy"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="Academy">
										<div class="form-control NoBorder" style="text-align: left">
											{{ Academy.AcademyDesc }}
										</div>
									</div>
								</ng-template>
								<ng-template let-AcademyItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ AcademyItem.AcademyDesc }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>

							<label>Homeroom:</label>
							<p-dropdown
								[disabled]="IsLoading() == true"
								[options]="lstHomeroom"
								[(ngModel)]="Homeroom"
								optionLabel="HomeRoom"
								[filter]="true"
								filterBy="HomeRoom"
								[showClear]="false"
								placeholder="Select a Homeroom"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="Homeroom">
										<div class="form-control NoBorder" style="text-align: left">
											{{ Homeroom.HomeRoom }}
										</div>
									</div>
								</ng-template>
								<ng-template let-HomeroomItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ HomeroomItem.HomeRoom }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>

							<label>Group:</label>
							<p-dropdown
								[disabled]="IsLoading() == true"
								[options]="lstGroup"
								[(ngModel)]="Group"
								optionLabel="GroupName"
								[filter]="true"
								filterBy="GroupName"
								[showClear]="false"
								placeholder="Select a Group"
							>
								<ng-template pTemplate="selectedItem">
									<div *ngIf="Group">
										<div class="form-control NoBorder" style="text-align: left">
											{{ Group.GroupName }}
										</div>
									</div>
								</ng-template>
								<ng-template let-GroupItem pTemplate="item">
									<div>
										<div class="form-control NoBorder" style="text-align: left">
											{{ GroupItem.GroupName }}
										</div>
									</div>
								</ng-template>
							</p-dropdown>

							<button
								style="grid-column: 1 / 7; width: fit-content; margin-left: auto; margin-right: auto"
								[disabled]="IsLoading() == true"
								class="btn btn-primary"
								(click)="onRefresh()"
							>
								Search
							</button>
						</div>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstBusStudentRideTxn"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedBusStudentRideTxn"
						dataKey="BusStudentRideTxnID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--StudentID-->
								<th>
									<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--StudentName-->
								<th>
									<p-columnFilter type="text" field="StudentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--SchoolFullName-->
								<th>
									<p-columnFilter type="text" field="SchoolFullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--BusNbr-->
								<th>
									<p-columnFilter type="text" field="BusNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--DriverName-->
								<th>
									<p-columnFilter type="text" field="DriverName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--BusRouteDesc-->
								<th>
									<p-columnFilter type="text" field="BusRouteDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--BusRouteTypeDesc-->
								<th>
									<p-columnFilter field="BusRouteTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterBusRouteTypeDesc
												[ngModel]="value"
												[options]="lstBusRouteTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--EntryTypeDesc-->
								<th>
									<p-columnFilter field="EntryTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterEntryTypeDesc
												[ngModel]="value"
												[options]="lstEntryTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--c_date-->
								<th>
									<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--Lat-->
								<th>
									<p-columnFilter type="text" field="Lat" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--Long-->
								<th>
									<p-columnFilter type="text" field="Long" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--HorizontalAccuracy-->
								<th>
									<p-columnFilter type="text" field="HorizontalAccuracy" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--ScanTypeDesc-->
								<th>
									<p-columnFilter field="ScanTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterScanTypeDesc
												[ngModel]="value"
												[options]="lstScanTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
								<th pSortableColumn="StudentName">Student<p-sortIcon field="StudentName"></p-sortIcon></th>
								<th pSortableColumn="SchoolFullName">School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
								<th pSortableColumn="BusNbr">Bus<p-sortIcon field="BusNbr"></p-sortIcon></th>
								<th pSortableColumn="DriverName">Driver<p-sortIcon field="DriverName"></p-sortIcon></th>
								<th pSortableColumn="BusRouteDesc">Route<p-sortIcon field="BusRouteDesc"></p-sortIcon></th>
								<th pSortableColumn="BusRouteTypeDesc">Route Type<p-sortIcon field="BusRouteTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="EntryTypeDesc">Entry Type<p-sortIcon field="EntryTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="c_date">Date/Time<p-sortIcon field="c_date"></p-sortIcon></th>
								<th pSortableColumn="Lat">Lat<p-sortIcon field="Lat"></p-sortIcon></th>
								<th pSortableColumn="Long">Long<p-sortIcon field="Long"></p-sortIcon></th>
								<th pSortableColumn="HorizontalAccuracy">Accuracy (ft, lower is better)<p-sortIcon field="HorizontalAccuracy"></p-sortIcon></th>
								<th pSortableColumn="ScanTypeDesc">Scan Type<p-sortIcon field="ScanTypeDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-BusStudentRideTxn>
							<tr [pSelectableRow]="BusStudentRideTxn" (dblclick)="onRowDblClick(BusStudentRideTxn)">
								<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
									{{ BusStudentRideTxn[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
